import React from "react";
import { Helmet } from "react-helmet";

import Content from "src/components/Blog/Content/Content";

const Blogs = () => {
  return (
    <div>
      {/* for testing seo
      <Helmet>
        <title>Blog - Eventmoon</title>‍
        <meta name="description" content="Eventmoon Blogs" />
        <meta property="og:title" content="Blog - Eventmoon" />
        <meta property="og:description" content="Eventmoon Blogs" />
        <meta property="og:image" content="url_to_image" />
        <meta property="og:url" content="https://eventmoon.com/#/blogs" />
      </Helmet> */}
      <Content />
    </div>
  );
};

export default Blogs;
